var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37109 7.64101H0.933594C0.882031 7.64101 0.839844 7.6832 0.839844 7.73476V8.43789C0.839844 8.48945 0.882031 8.53164 0.933594 8.53164H9.37109C9.42266 8.53164 9.46484 8.48945 9.46484 8.43789V7.73476C9.46484 7.6832 9.42266 7.64101 9.37109 7.64101ZM3.6875 2.31718H4.55352V6.28164C4.55352 6.3332 4.5957 6.37539 4.64727 6.37539H5.35039C5.40195 6.37539 5.44414 6.3332 5.44414 6.28164V2.31718H6.3125C6.39102 2.31718 6.43437 2.22695 6.38633 2.16601L5.07383 0.504293C5.06506 0.493088 5.05385 0.484026 5.04106 0.477794C5.02827 0.471562 5.01423 0.468323 5 0.468323C4.98577 0.468323 4.97173 0.471562 4.95894 0.477794C4.94615 0.484026 4.93494 0.493088 4.92617 0.504293L3.61367 2.16484C3.56563 2.22695 3.60898 2.31718 3.6875 2.31718Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallIcon);
export default __webpack_public_path__ + "static/media/install-icon.13fa1a3125d006ed60c4ae5f7cddc17c.svg";
export { ForwardRef as ReactComponent };